import React from 'react';
import { connect } from 'react-redux';
import {
  ListGroupItem,
  Button,
} from 'react-bootstrap';

import {
  tokenGetMetadata,
  auctionFinalize,
} from '../util/thunks';

class WonAuction extends React.Component {

  componentWillMount() {
    this.props.tokenGetMetadata();
  }

  render() {
    return (
      <ListGroupItem>

        Won -

        {this.props.metadata &&
          <p>{this.props.metadata.name}</p>
        }

        <Button onClick={this.props.auctionFinalize}>Claim Card</Button>
      </ListGroupItem>
    );
  }

}

const mapStateToProps = (state, ownProps) => {
  return {
    metadata: state.tokenMetadata.paths[ownProps.auction.tokenURI],
  };
};

const mapDispatchToProps = (dispatch, ownProps) => ({

  tokenGetMetadata: () => {
    return dispatch(tokenGetMetadata(ownProps.auction.tokenURI));
  },

  auctionFinalize: () => {
    return dispatch(auctionFinalize([ownProps.auction.auctionIndex]));
  },

});

export default connect(mapStateToProps, mapDispatchToProps)(WonAuction);



// WEBPACK FOOTER //
// ./src/components/WonAuction.js